import * as Progress from "@radix-ui/react-progress";

export function ProgressBar({ current, total }: { current: number; total: number }) {
  const value = total > 0 ? Math.round(((current + 1) / total) * 100) : 0;
  return (
    <div className="space-y-2">
      <div className="flex items-baseline justify-between text-xs text-fg-muted">
        <span>
          Frage {Math.min(current + 1, total)} von {total}
        </span>
        <span className="tabular-nums">{value}%</span>
      </div>
      <Progress.Root
        value={value}
        max={100}
        className="relative h-1.5 w-full overflow-hidden rounded-full bg-border"
      >
        <Progress.Indicator
          className="h-full rounded-full bg-accent transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${100 - value}%)` }}
        />
      </Progress.Root>
    </div>
  );
}
